<div *ngIf="auction()">
  <!-- Image Mobile-->
  <ng-container *ifScreenSize="screenSize.Mobile">
    <div class="loyalty-details-image card border-0 overflow-hidden p-0 fgbcl-rewards-image">
      <img
        class="card-img"
        src="{{ auction().ImageUrl | contentImage: '7' : 'auction' }}"
        [alt]="auction().ItemName"
        draggable="false"
      />
      <fgbcl-social-share-modal
        shareType="rewards"
        [itemId]="auctionId"
        urlPage="rewards/auctions/details"
        [loyaltyCategoryType]="loyaltyCategoryType"
      ></fgbcl-social-share-modal>
      <!-- Auction Status -->
      <div class="card-img-overlay p-0">
        <ng-container [ngSwitch]="auction().Status">
          <div *ngSwitchCase="auctionStatus.UserWinning" class="status winning p-0 auction-mobile">
            <span>{{ 'auction.winning.status' | translate }}</span>
          </div>
          <div *ngSwitchCase="auctionStatus.UserLosing" class="status outbid p-0 auction-mobile">
            <span>{{ 'auction.outbid.status' | translate }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <div class="container">
    <div class="d-block d-lg-flex">
      <!-- Image -->
      <ng-container *ifScreenSize="screenSize.Desktop">
        <div class="loyalty-details-image card border-0 p-0">
          <img
            class="card-img"
            src="{{ auction().ImageUrl | contentImage: '7' : 'auction' }}"
            [alt]="auction().ItemName"
            draggable="false"
          />
          <fgbcl-social-share-modal
            shareType="rewards"
            [itemId]="auctionId"
            urlPage="rewards/auctions/details"
            [loyaltyCategoryType]="loyaltyCategoryType"
          ></fgbcl-social-share-modal>
          <!-- Auction Status -->
          <div class="card-img-overlay p-0">
            <ng-container [ngSwitch]="auction().Status">
              <div *ngSwitchCase="auctionStatus.UserWinning" class="status winning position-absolute p-0 text-center">
                <span>{{ 'auction.winning.status' | translate }}</span>
              </div>
              <div *ngSwitchCase="auctionStatus.UserLosing" class="status outbid position-absolute p-0 text-center">
                <span>{{ 'auction.outbid.status' | translate }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- Details -->
      <div class="loyalty-details">
        <!--Sponsor-->
        <ng-container *ngIf="auction()?.Sponsor?.SponsorImage">
          <div class="rewards-details-sponsor">
            <span class="rewards-details-sponsor-text"> {{ auction()?.Sponsor?.SponsorText }} </span>
            <a
              [attr.href]="auction()?.Sponsor?.SponsorLink || null"
              [attr.target]="auction()?.Sponsor?.SponsorLink ? '_blank' : null"
            >
              <img src="{{ auction()?.Sponsor?.SponsorImage | contentImage: '7' : 'auction' }}" />
            </a>
          </div>
        </ng-container>
        <h2 class="rewards-item-name">{{ auction().ItemName }}</h2>
        <!-- Card Body -->
        <div class="d-flex flex-column justify-content-between">
          <!-- Enabled Item Display -->
          <ng-container *ifItemEnabled="auction(); else disabledTemplate">
            <!-- Item Details -->
            <!-- End Time -->
            <fgbcl-countdown
              class="font-size-14 countdown-color rewards-item-end-date"
              [endDateTime]="auction().EndDate"
              (complete)="auctionTimeEnd($event)"
            ></fgbcl-countdown>
            <!-- Current Bid Value  -->
            <div class="auction-details-points">
              <span class="rewards-item-details">{{ currentValue | number }} {{ 'fgbcl.currency.pts' | translate }}</span>
            </div>
            <!-- Action button template -->
            <!--Terms and Condtions Checkbox-->
            <ng-container *ngIf="auction().ShowTermsAndConditions">
              <div class="form-check rewards-accept-terms-checkbox">
                <input class="form-check-input" id="checkbox" type="checkbox" [(ngModel)]="termsAccepted" />
                <label
                  [ngClass]="termsAccepted ? 'rewards-terms-checked' : 'rewards-terms-unchecked'"
                  class="rewards-terms-label ms-1"
                  for="checkbox"
                >
                  {{ 'auction.terms.accept' | translate }}
                </label>
              </div>
            </ng-container>
            <div class="rewards-button-background">
              <div class="rewards-button-container">
                <div
                  class="justify-content-center align-items-center rewards-quantity-field-container"
                  *ngIf="
                    auctionEnd || auction().PointsValue > availableBalance || (isWinning() && !auction().AllowSelfBid)
                      ? false
                      : true
                  "
                >
                  <fgbcl-number-input
                    [isActive]="auctionEnd || (isWinning() && !auction().AllowSelfBid) ? false : true"
                    [minValue]="auction().HasPreviousSuccessfulBid ? currentValue + auction().BidIncrement : currentValue"
                    [maxValue]="availableBalance"
                    [incrementValue]="auction().BidIncrement"
                    [minMessage]="'error.auctionBid-valueLowerThanMinimumBidValue' | translate: { minBid: minBidAmount }"
                    [maxMessage]="'error.user-insufficientFunds' | translate"
                    [(amount)]="bidAmount"
                    [(outOfRange)]="isBidOutOfRange"
                    [showErrorMessage]="false"
                    theme="auction"
                    [limitValueToRange]="undefined"
                    (errorChange)="onErrorChange($event)"
                  >
                  </fgbcl-number-input>
                </div>
                <button
                  [disabled]="
                    (isWinning() && !auction().AllowSelfBid) ||
                    bidAmount > availableBalance ||
                    auctionEnd ||
                    isBidOutOfRange ||
                    (auction().ShowTermsAndConditions && !termsAccepted)
                  "
                  class="btn fw-bold btn-rewards-redeem"
                  type="button"
                  (click)="openConfirmation()"
                >
                  {{ 'auction.bid.now' | translate }}
                </button>
              </div>
            </div>
          </ng-container>
          <!-- Error -->
          <fgbcl-error></fgbcl-error>
          <!-- Disabled Item Display -->
          <ng-template #disabledTemplate let-status>
            <ng-container *ngIf="status.type !== STATUS.COMING_SOON">
              <!-- End Time -->
              <div class="auction-details-countdown">
                <fgbcl-countdown class="font-size-14 countdown-color" [endDateTime]="auction().EndDate"></fgbcl-countdown>
              </div>
            </ng-container>
            <!-- Current Bid Value  -->
            <div class="auction-details-points">
              <span class="rewards-item-details">{{ currentValue | number }} {{ 'fgbcl.currency.pts' | translate }}</span>
            </div>
            <!-- Disabled Status -->
            <div class="status-container">
              <fgbcl-reward-status
                [status]="status.data"
                [startDate]="auction().RequestTime"
                [comingSoonDate]="auction().StartDate"
                (itemStart)="status.refresh(true)"
              ></fgbcl-reward-status>
            </div>
          </ng-template>

          <!-- Description & Terms  -->
          <div class="rewards-details-desc-terms accordion accordion-flush" id="marketplaceDescTerms">
            <div class="accordion-item rewards-accordion-item">
              <div id="marketplace-description">
                <button
                  class="accordion-button rewards-item-description-title rewards-accordion-item"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#marketplaceDesc"
                  aria-expanded="true"
                >
                  {{ 'auction.item.description' | translate }}
                </button>
              </div>
              <div id="marketplaceDesc" class="accordion-collapse collapse show" data-bs-parent="#marketplaceDescTerms">
                <div class="rewards-item-description" [innerHtml]="auction().ItemDescription | safeHtml"></div>
              </div>
            </div>
            <ng-container *ngIf="auction().ShowTermsAndConditions">
              <div class="accordion-item rewards-accordion-item">
                <div class="accordion-header" id="marketplace-terms">
                  <button
                    class="accordion-button collapsed rewards-item-terms rewards-accordion-item"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#marketplaceTerms"
                    aria-expanded="false"
                  >
                    {{ 'auction.item.tcs' | translate }}
                  </button>
                </div>
                <div id="marketplaceTerms" class="accordion-collapse collapse" data-bs-parent="#marketplaceDescTerms">
                  <!--Text T&Cs-->
                  <ng-container *ngIf="auction().TermsAndConditionsType === TermsAndCondtionsType.Text">
                    <div class="rewards-item-terms-text" [innerHtml]="auction().TermsAndConditions | safeHtml"></div>
                  </ng-container>
                  <!--URL T&Cs-->
                  <ng-container *ngIf="auction().TermsAndConditionsType === TermsAndCondtionsType.URL">
                    <a [href]="auction().TermsAndConditions" target="_blank" class="rewards-item-terms-url">
                      {{ auction().TermsAndConditions }}</a
                    >
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
